export default __webpack_public_path__ + "static/Folleto-57e72d03db9e1b5a519cf0d601bcc45d.jpg";